export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 42 32" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100-V1.2版本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MM100众筹详情-RV" transform="translate(-400.000000, -9709.000000)">
                    <g id="编组-33" transform="translate(0.000000, 6400.000000)">
                        <g id="编组-26" transform="translate(400.000000, 2927.000000)">
                            <g id="编组-24" transform="translate(0.000000, 381.000000)">
                                <g id="5-in-1" transform="translate(0.000000, 1.000000)">
                                    <rect id="矩形" fillOpacity="0" fill="#000000" x="0" y="0" width="42" height="32"></rect>
                                    <rect id="矩形" stroke="#000000" strokeWidth="2.08" x="1.04" y="1.04" width="5.37784588" height="5.49400697"></rect>
                                    <rect
                                        id="矩形备份-30"
                                        stroke="#000000"
                                        strokeWidth="2.08"
                                        x="9.17583187"
                                        y="1.04"
                                        width="5.37784588"
                                        height="5.49400697"
                                    ></rect>
                                    <rect
                                        id="矩形备份-31"
                                        stroke="#000000"
                                        strokeWidth="2.08"
                                        x="17.9896497"
                                        y="1.04"
                                        width="5.37784588"
                                        height="5.49400697"
                                    ></rect>
                                    <rect
                                        id="矩形备份-32"
                                        stroke="#000000"
                                        strokeWidth="2.08"
                                        x="26.1254816"
                                        y="1.04"
                                        width="5.37784588"
                                        height="5.49400697"
                                    ></rect>
                                    <rect
                                        id="矩形备份-33"
                                        stroke="#000000"
                                        strokeWidth="2.08"
                                        x="34.9392994"
                                        y="1.04"
                                        width="5.37784588"
                                        height="5.49400697"
                                    ></rect>
                                    <g
                                        id="编组-34"
                                        transform="translate(16.949650, 6.862270)"
                                        stroke="#000000"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="1.31330409"
                                    >
                                        <path
                                            d="M5.20827516,6.40501257 L1.18820262,6.1104087 L0.893598744,2.09033616"
                                            id="路径"
                                            transform="translate(3.050937, 4.247674) rotate(-45.000000) translate(-3.050937, -4.247674) "
                                        ></path>
                                    </g>
                                    <rect
                                        id="矩形"
                                        stroke="#000000"
                                        strokeWidth="2.08"
                                        x="9.17583187"
                                        y="17.8919861"
                                        width="22.3274956"
                                        height="13.0680139"
                                    ></rect>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
